(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[195],{

/***/ 4359:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog",
      function () {
        return __webpack_require__(7886);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 7886:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ blog; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(6383);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(2228);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
// EXTERNAL MODULE: ./components/NewHeader/index.tsx + 19 modules
var NewHeader = __webpack_require__(614);
// EXTERNAL MODULE: ./components/About/index.ts + 12 modules
var About = __webpack_require__(5710);
// EXTERNAL MODULE: ./components/Blog/BlogMainSection.tsx + 1 modules
var BlogMainSection = __webpack_require__(7406);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(5505);
// EXTERNAL MODULE: ./public/asset/blog/blog-main-visual.png
var blog_main_visual = __webpack_require__(7696);
// EXTERNAL MODULE: ../../packages/global-styles/index.ts
var global_styles = __webpack_require__(9059);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../packages/assets/icons.tsx
var icons = __webpack_require__(1089);
// EXTERNAL MODULE: ../../node_modules/seamless-scroll-polyfill/lib/scroll.js + 1 modules
var lib_scroll = __webpack_require__(5378);
// EXTERNAL MODULE: ../../node_modules/next/image.js
var next_image = __webpack_require__(6577);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./styles/breakPoints.ts
var breakPoints = __webpack_require__(3081);
// EXTERNAL MODULE: ./components/Common/CommonWrappers.tsx
var CommonWrappers = __webpack_require__(5564);
// EXTERNAL MODULE: ../../packages/global-styles/MainButton.tsx
var MainButton = __webpack_require__(8920);
;// CONCATENATED MODULE: ./components/Blog/BlogMainVisual.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "margin-top:56px;"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}












var KO = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "ko-wrapper",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* SubtitleM */.sy, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: "미디어 트렌드 및 동영상 기술을 제공하는 블루닷의 노하우를 전합니다."
            })
        })
    });
};
var EN = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "ko-wrapper",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* SubtitleM */.sy, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: "Media Trend, Video Technology, and BLUEDOT News"
            })
        })
    });
};
var BlogMainVisual = /*#__PURE__*/ (0,react.memo)(function() {
    var locale = (0,router.useRouter)().locale;
    var handleClickLearnMore = function() {
        var $heightContainer = document.querySelector(".main-section-container");
        if ($heightContainer) {
            (0,lib_scroll/* scrollTo */.X5)(window, {
                top: $heightContainer.getBoundingClientRect().height,
                behavior: "smooth"
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BlogMainVisualContainer, {
        className: "main-section-container",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CommonWrappers/* ImgBackgroundWrapper */.Yo, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: blog_main_visual/* default.src */.Z.src,
                    layout: "fill",
                    alt: "bluedot blog",
                    className: "target-img",
                    objectFit: "cover",
                    sizes: "(min-width: 906px) 90vw, (min-width: 600px) 88vw, (max-width: 599px) 80vw",
                    loading: "eager",
                    quality: 30,
                    priority: true
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CommonWrappers/* MainVisualInnerContainer */.rO, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles.H1, {
                        className: "main-typo",
                        as: "h2",
                        children: "Blog"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "desc-text-wrapper",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "anim-wrapper",
                            children: locale === "en" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(EN, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(KO, {})
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MainButton/* MainButton */.c, {
                        buttonType: "default-w",
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* AboutLearnMoreArrow */.wG, {}),
                        iconPosition: "right",
                        injectCssStyles: [
                            (0,breakPoints/* generateCssStyle */.m)({
                                "margin-top": "32px",
                                animation: "txtAnimation 0.8s 1.5s cubic-bezier(0.4, 0, 0.2, 1) backwards"
                            }),
                            breakPoints/* mediaQueryStyle.M */.Pm.M(_templateObject()), 
                        ],
                        injectInlineStyles: {
                            width: "328px",
                            height: "56px"
                        },
                        text: locale === "en" ? "Learn more" : "더 알아보기",
                        onClick: handleClickLearnMore
                    })
                ]
            })
        ]
    });
});
BlogMainVisual.displayName = "BlogMainVisual";
var BlogMainVisualContainer = (0,styled_components_browser_esm/* default */.ZP)(CommonWrappers/* MainVisualOuterContainer */.XY).withConfig({
    displayName: "BlogMainVisual__BlogMainVisualContainer",
    componentId: "sc-bbb3a278-0"
})(_templateObject1());

// EXTERNAL MODULE: ./components/Common/FloatingController.tsx
var FloatingController = __webpack_require__(1924);
// EXTERNAL MODULE: ./components/Footer/Footer.tsx
var Footer = __webpack_require__(2587);
// EXTERNAL MODULE: ./components/Global/index.ts + 16 modules
var Global = __webpack_require__(6402);
// EXTERNAL MODULE: ../../node_modules/react-intersection-observer/react-intersection-observer.modern.mjs
var react_intersection_observer_modern = __webpack_require__(299);
// EXTERNAL MODULE: ../../node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(5351);
// EXTERNAL MODULE: ./public/asset/bluedot-metatag-img.png
var bluedot_metatag_img = __webpack_require__(2446);
;// CONCATENATED MODULE: ./pages/blog/index.tsx


function blog_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n"
    ]);
    blog_templateObject = function _templateObject() {
        return data;
    };
    return data;
}













var Index = function() {
    var ref = (0,_sliced_to_array/* default */.Z)((0,react_intersection_observer_modern/* useInView */.YD)({
        fallbackInView: true
    }), 3), $fakeHeaderRef = ref[0], isFakeHeaderVisible = ref[1], fakeHeaderEntry = ref[2];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BlogMainContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
                title: "Blog - BLUEDOT",
                description: "미디어 소식과 동영상 솔루션을 제공하는 블루닷의 기술과 노하우를 전합니다.",
                canonical: "https://blue-dot.io/blog/",
                openGraph: {
                    url: "https://blue-dot.io/blog/",
                    title: "Blog - BLUEDOT",
                    description: "미디어 소식과 동영상 솔루션을 제공하는 블루닷의 기술과 노하우를 전합니다.",
                    images: [
                        {
                            url: bluedot_metatag_img/* default.src */.Z.src,
                            alt: "BLUEDOT INC.",
                            type: "image/png"
                        }, 
                    ],
                    siteName: "BLUEDOT"
                },
                twitter: {
                    handle: "@handle",
                    site: "@site",
                    cardType: "summary_large_image"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Global/* BypassBlock */.ok, {
                contentSectionId: "#blog-content1"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "io-target",
                ref: $fakeHeaderRef
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NewHeader/* default */.Z, {
                isScrolled: !isFakeHeaderVisible && !!(fakeHeaderEntry === null || fakeHeaderEntry === void 0 ? void 0 : fakeHeaderEntry.target)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BlogMainVisual, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BlogMainSection/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(About/* AboutCheckoutProduct */.yz, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FloatingController/* default */.Z, {
                isVisible: isFakeHeaderVisible
            })
        ]
    });
};
/* harmony default export */ var blog = (Index);
var BlogMainContainer = (0,styled_components_browser_esm/* default */.ZP)(CommonWrappers/* PageOuterContainer */.px).withConfig({
    displayName: "blog__BlogMainContainer",
    componentId: "sc-9c4e4285-0"
})(blog_templateObject());


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [726,769,351,605,572,352,710,266,774,888,179], function() { return __webpack_exec__(4359); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);